
class ErrorModalController {
    constructor($uibModalInstance, data) {
        this.text = data.text;

        if (data.type === 'feasibility') {
            this.text = 'Solver error, please try modified geometry file.';
        } else if (data.type === 'nest') {
            this.text = 'Nester error, please try modified Blank outline.';
        }

        this._$uibModalInstance = $uibModalInstance;
    }

    close() {
        this._$uibModalInstance.close();
    }
}

ErrorModalController.$inject = ['$uibModalInstance', 'data'];

export default ErrorModalController;



// WEBPACK FOOTER //
// ./client/app/common/error-widget/error-notification-modal.controller.js